import { useEffect } from "react";
import { Spinner } from "@/ui";
import { useAuth0 } from "@auth0/auth0-react";
import Cookies from "js-cookie";
import { TASK_ID_KEY } from "@/entities/CreditBox/useCreditboxes";

function LogoutRedirect() {
    const { logout } = useAuth0();

    useEffect(() => {
        logout();
        const taskId = localStorage.getItem(TASK_ID_KEY);
        localStorage.clear();
        // restore taskId if it exists
        if (taskId) {
            localStorage.setItem(TASK_ID_KEY, taskId);
        }
        sessionStorage.clear();
        Cookies.remove(process.env.TOKEN_COOKIE);
        console.log("user logged out");
    }, [logout]);

    return (
        <>
            <Spinner fullScreen />
            <p className="sr-only">Logout Page</p>
        </>
    );
}

export default LogoutRedirect;
